import * as React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@material-ui/core'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'


interface IProps extends WithI18n {
  open: boolean;
  title?: string;
  fullWidth?: boolean
  children: React.ReactElement<any>;
  onClose: () => void;
  actions: () => void;
  maxWidth?: any;
}

class PcDialog extends React.Component<IProps, any> {
    render() {
        const {
            open, onClose, title, children, actions, maxWidth, fullWidth
        } = this.props;
        return(
            <Dialog
                disableEnforceFocus
                open={open}
                onClose={onClose}
                maxWidth={maxWidth || "sm"}
                fullWidth={fullWidth}
            >
                {title&&
                    <DialogTitle style={{paddingBottom: '10px'}}>{title}</DialogTitle>
                }
                <DialogContent>
                    {children}
                </DialogContent>
                {actions &&
                    <DialogActions>
                    {actions}
                    </DialogActions>
                }
            </Dialog>
        )
    }
}

export default withI18n(PcDialog)



// WEBPACK FOOTER //
// ./src/shared/Dialog/PcDialog.tsx